import React, { useMemo } from 'react';
import { GeoJSONLayer } from 'react-mapbox-gl';
import PropTypes from 'prop-types';
import { useTheme } from '@material-ui/core';
import { CoordinatesExact } from '../../models/Coordinates';
import { hexToRgba } from '../../../common/formatters/colorFormatter';

const UrbanArea = ({ index, coordinatesArray, visible }) => {
  const theme = useTheme();

  const sourceData = useMemo(
    () => ({
      type: 'Feature',
      geometry: {
        type: 'Polygon',
        coordinates: visible ? [coordinatesArray.map(({ longitude, latitude }) => [longitude, latitude])] : [],
      },
    }),
    [visible, coordinatesArray]
  );

  return (
    <GeoJSONLayer
      id={`urbanArea${index}`}
      data={sourceData}
      fillPaint={{
        'fill-color': hexToRgba(theme.palette.map.urbanArea, 0.4),
        'fill-outline-color': theme.palette.map.urbanArea,
      }}
    />
  );
};

UrbanArea.propTypes = {
  coordinatesArray: PropTypes.arrayOf(CoordinatesExact),
  index: PropTypes.number,
  visible: PropTypes.bool,
};

UrbanArea.defaultProps = {
  coordinatesArray: [],
  index: 0,
  visible: true,
};

export default React.memo(UrbanArea);
